import createConfig from './EnvConfig';
import defaultServerConfig from './lib/defaultServerConfig';
import { ServerConfig } from './types/ServerConfig';

if (typeof window === 'undefined') {
    defaultServerConfig.validate();
}
const config = createConfig<ServerConfig>({
    namespace: 'jucy.serverConfig',
    defaultConfig: defaultServerConfig.getProperties(),
});

export default config;
